// get reducer data (fromJS object) and convert it to plain JSObject
export const convertState = (state, reducer) => state[reducer].toJS()



// WEBPACK FOOTER //
// ./src/utils/state.js